import { companiesRepo } from '@/constants/providers';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { UserKey } from '@/modules/Users/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { DisassociateCompanyUserModel } from '../types/disassociate-company-user-model';
import { CompanyKeys } from './keys';

export const useDisassociateCompanyUser = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, unknown, DisassociateCompanyUserModel>(
    (disassociateUserCompany) =>
      companiesRepo.disassociateUser(disassociateUserCompany),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(UserKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(OrganizationKeys.ALL);
      },
      onError: () => {
        toast.error(t('error.disassociate_user_company'));
      },
    },
  );
};
